import { ViewZonePageComponent } from "./view-zone-page/view-zone-page.component";
import { AddZonePageComponent } from "./add-zone-page/add-zone-page.component";
import { ZoneListPageComponent } from "./zone-list-page/zone-list-page.component";
import { ViewCityPageComponent } from "./view-city-page/view-city-page.component";
import { AddCityPageComponent } from "./add-city-page/add-city-page.component";
import { CityListPageComponent } from "./city-list-page/city-list-page.component";
import { ViewStatePageComponent } from "./view-state-page/view-state-page.component";
import { AddStatePageComponent } from "./add-state-page/add-state-page.component";
import { StatesListPageComponent } from "./states-list-page/states-list-page.component";
import { ViewCourierPageComponent } from "./view-courier-page/view-courier-page.component";
import { CourierListPageComponent } from "./courier-list-page/courier-list-page.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { HomeComponent } from "./home/home.component";
import { ProductListComponent } from "./product-list/product-list.component";
import { ProductViewComponent } from "./product-view/product-view.component";
import { LoginComponent } from "./login/login.component";
import { NeedAuthGuard } from "./_shared/NeedAuthGuard ";
import { ProductAddComponent } from "./product-add/product-add.component";
import { CountryListPageComponent } from "./country-list-page/country-list-page.component";
import { AddCountryPageComponent } from "./add-country-page/add-country-page.component";
import { ViewCountryPageComponent } from "./view-country-page/view-country-page.component";
import { AddCourierPageComponent } from "./add-courier-page/add-courier-page.component";

const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "home", component: HomeComponent, canActivate: [NeedAuthGuard] },
  {
    path: "products",
    component: ProductListComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "products/add",
    component: ProductAddComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "products/:id",
    component: ProductViewComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/states",
    component: StatesListPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/states/add",
    component: AddStatePageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/states/:id",
    component: ViewStatePageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/zones",
    component: ZoneListPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/zones/add",
    component: AddZonePageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/zones/:id",
    component: ViewZonePageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/cities",
    component: CityListPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/cities/add",
    component: AddCityPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/cities/:id",
    component: ViewCityPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/courier",
    component: CourierListPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/courier/add",
    component: AddCourierPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/courier/:id",
    component: ViewCourierPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/country",
    component: CountryListPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/country/add",
    component: AddCountryPageComponent,
    canActivate: [NeedAuthGuard],
  },
  {
    path: "regional/country/:id",
    component: ViewCountryPageComponent,
    canActivate: [NeedAuthGuard],
  },
  { path: "**", redirectTo: "home" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
